class a {
  static injectJwtToken(e, t) {
    t.defaults.headers.common.Authorization = `bearer ${e}`;
  }
}
export {
  a as JwtToken
};
